import { customStyle, styleEnd } from "../../algorithms/styleDirection";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment/locale/ar";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Lang from "../../userPreferences/staticWords";
import DetailsPopup from "./projectDetailsPopup";
import { paths } from "../../paths/paths";
import ModalComponent from "../reusableComponents/modal";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import Titlebar from "../layout/titlebar";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  getAllProjectAttachments,
  getEditDataMilestoneForm,
  getEditDataProjectForm,
  getProjectMilestones,
} from "../../API/store/actions/projects/projects";
import ActivityCard from "./activityCard";
import Button from "../sharedComponents/buttons/button";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import DeleteProcAlert from "../tasks/editProc.js/deleteProc";
import Pulse from "react-reveal/Pulse";
import EditMilestone from "./editMilestone";
import CreateNewActivity from "./createNewActivity";
import ProjectAttachmentsPopup from "./projectAttachmentsPopup";
import AddTaskAttachments from "../tasks/addTaskAttachmentPopup";
import AddMilestone from "./addMilestone";
import EditProjectForm from "./editProject/editProjectForm";
import EditProjectStatus from "./editProjectStatus/projStatus";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
const ProjectDetails = (props) => {
  const { setProcAdded, procAdded, id } = props;
  const history = useNavigate();
  const [display, setDisplay] = useState(false);
  const [showTaskAttachmentsPopup, setshowTaskAttachmentsPopup] = useState(
    false
  );
  const [projectAttachmentsContent, setprojectAttachmentsContent] = useState(
    []
  );
  const communityId = useSelector((state) => state.community.communityId?.id);

  const onshowTaskAttachmentsPopup = () => {
    setshowTaskAttachmentsPopup(true);
  };

  const [details, setDetails] = useState({});

  const renderProjectAttachmentsModal = () => {
    return (
      <ProjectAttachmentsPopup
        name={details.name}
        content={projectAttachmentsContent}
        show={showTaskAttachmentsPopup}
        onHide={() => setshowTaskAttachmentsPopup(false)}
      />
    );
  };

  useEffect(() => {
    setDetails(props.ProjectDetails.data);
  }, [props.ProjectDetails.data]);

  const [show, setShow] = useState(false);

  const onShow = () => {
    setShow(true);
  };
  const community = useSelector((state) => state.community.communityId);

  const [AdminTaskMembersList, setAdminTaskMembersList] = useState([]);
  const [TaskMembersList, setTaskMembersList] = useState([]);

  const [TaskStatusDropdownList, setTaskStatusDropdownList] = useState([]);
  const [PriorityDropdownList, setPriorityDropdownList] = useState([]);

  const renderModal = () => {
    return (
      <CreateNewActivity
        AdminTaskMembersList={AdminTaskMembersList}
        setAdminTaskMembersList={setAdminTaskMembersList}
        TaskMembersList={TaskMembersList}
        setTaskMembersList={setTaskMembersList}
        TaskStatusDropdownList={TaskStatusDropdownList}
        setTaskStatusDropdownList={setTaskStatusDropdownList}
        PriorityDropdownList={PriorityDropdownList}
        setPriorityDropdownList={setPriorityDropdownList}
        communityId={communityId} //when we put communities
        isActivity={true}
        milestones={details.milestones}
        projectId={id}
        setProcAdded={setProcAdded}
        procAdded={procAdded}
        show={show}
        onHide={() => setShow(false)}
      />
    );
  };

  const [showDetailsPopup, setShowDetailsPopup] = useState(false);

  const onshowDetailsPopup = () => {
    setShowDetailsPopup(true);
  };

  const renderDetailsModal = (details) => {
    return (
      <DetailsPopup
        name={details.name}
        content={details}
        show={showDetailsPopup}
        onHide={() => setShowDetailsPopup(false)}
      />
    );
  };

  const [showEditMilestonePopup, setShowEditMilestonePopup] = useState(false);

  const onshowEditMilesonePopup = () => {
    setShowEditMilestonePopup(true);
  };

  const [milestone, setMilestone] = useState({});

  const renderEditMilestoneModal = () => {
    return (
      <EditMilestone
        projectId={id}
        milestoneId={milestoneId}
        setProjAdded={setProcAdded}
        projAdded={procAdded}
        name={milestones?.name}
        data={dropdowns?.data}
        show={showEditMilestonePopup}
        onHide={() => setShowEditMilestonePopup(false)}
      />
    );
  };

  const [visibleProc, setVisibleProc] = useState(false);
  const [milestones, setMilestones] = useState(false);
  const userToken = useSelector((state) => state.login.userToken);
  const [dropdowns, setDrobdowns] = useState({});
  const reload = useSelector((state) => state.reload.reload);

  useEffect(() => {
    resolver(
      getAllProjectAttachments,
      setprojectAttachmentsContent,
      id,
      1,
      10,
      userToken
    );
    resolver(getProjectMilestones, setMilestones, id, 1, 10, userToken);

    if (Lang.getLanguage() === "ar") moment.locale("ar");
    else moment.locale("en");
  }, [reload]);

  const [milestoneId, setMilestoneId] = useState(0);
  useEffect(() => {
    if (milestoneId != 0)
      resolver(
        getEditDataMilestoneForm,
        setDrobdowns,
        milestoneId,
        id,
        userToken
      );
  }, [milestoneId]);

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteProjectModalVisible, setDeleteProjectModalVisible] = useState(
    false
  );

  // ellipses logic
  const [showProject, setshowProject] = useState({ id: null, display: false });
  const [data, setData] = useState(null);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [projectTitle, setProjectTitle] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const [visibleStatus, setVisibleStatus] = useState(false);
  const [showAttachmentPopup, setShowAttachmentPopup] = useState(false);

  const onShowAttachments = () => {
    setShowAttachmentPopup(true);
  };
  const renderAttachmentsModal = () => {
    return (
      <AddTaskAttachments
        procAdded={procAdded}
        setProcAdded={setProcAdded}
        projectId={projectId}
        show={showAttachmentPopup}
        onHide={() => setShowAttachmentPopup(false)}
      />
    );
  };
  useEffect(() => {
    if (data) setVisibleEdit(true);
  }, [data]);

  const [showMilestonePopup, setShowMilestonePopup] = useState(false);

  const onShowMilestonePopup = () => {
    setShowMilestonePopup(true);
  };

  const renderMilestoneModal = () => {
    return (
      <AddMilestone
        projectId={projectId}
        setProjAdded={setProcAdded}
        projAdded={procAdded}
        show={showMilestonePopup}
        onHide={() => setShowMilestonePopup(false)}
      />
    );
  };

  window.onclick = function (event) {
    if (
      !event.target.matches(".icon") &&
      !event.target.matches(".icon svg path")
    ) {
      var sharedowns = document.getElementsByClassName(
        `${customStyle("dropdown-menuProjectDetails")}`
      );
      for (let i = 0; i < sharedowns?.length; i++) {
        var openSharedown = sharedowns[i];
        if (openSharedown?.classList?.contains("show")) {
          openSharedown?.classList?.remove("show");
          setshowProject({ id: null, display: false });
        }
      }
    }
  };

  if (details) {
    return (
      <>
        <ModalComponent
          body={
            <EditProjectForm
              communityId={communityId}
              projectTitle={projectTitle}
              projectId={projectId}
              setVisible={setVisibleEdit}
              data={data?.data}
              setProjAdded={setProcAdded}
              projAdded={procAdded}
              userToken={userToken}
            />
          }
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleEdit}
          modalVisible={visibleEdit}
          size={"xl"}
          title={Lang.editProject}
        />
        <ModalComponent
          body={
            <EditProjectStatus
              communityId={communityId}
              userToken={userToken}
              projectId={projectId}
              setVisible={setVisibleEdit}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />
          }
          hasImage={
            <img
              src="/assets/images/icons/status.png"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleStatus}
          modalVisible={visibleStatus}
          size={"xl"}
          title={Lang.editStatus}
        />
        <ModalComponent
          body={
            <DeleteProcAlert
              userToken={userToken}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              milestoneId={milestoneId}
              setVisible={setDeleteModalVisible}
              content={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? "هل تريد حذف المرحلة والأنشطة الملحقة ؟"
                  : "Do you want to delete this Milestone and Activities that depends on it ?"
              }
            />
          }
          size={"s"}
          modalVisible={deleteModalVisible}
          setModalVisible={setDeleteModalVisible}
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={
            getDir(getCurrentLangFromRedux()) == "rtl"
              ? "هل انت متاكد ؟"
              : "Are you sure ?"
          }
          background={"modalBackground mx-5"}
        />
        <ModalComponent
          body={
            <DeleteProcAlert
              internal={true}
              userToken={userToken}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              projectId={projectId}
              setVisible={setDeleteProjectModalVisible}
              content={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? "هل تريد حذف المشروع والمراحل والأنشطة الملحقة ؟"
                  : "Do you want to delete this Project, Milestones and Activities that depends on it ?"
              }
            />
          }
          size={"s"}
          modalVisible={deleteProjectModalVisible}
          setModalVisible={setDeleteProjectModalVisible}
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={
            getDir(getCurrentLangFromRedux()) == "rtl"
              ? "هل انت متاكد ؟"
              : "Are you sure ?"
          }
          background={"modalBackground mx-5"}
        />
        {/* <ModalComponent
          body={
            <AddProcedureForm
              taskId={details.id}
              setVisible={setVisibleProc}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />
          }
          hasImage={
            <div
              style={{
                backgroundColor: "#1A73E8",
                height: 26,
                width: 26,
                cursor: "pointer",
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center itemNav plusIcon"
            >
              <div
                style={{
                  width: 16,
                  height: 16,
                  background:
                    "url('/assets/images/icons/Path 184.png') 0% 0% no-repeat padding-box",
                  opacity: 1,
                  filter: "opacity(1) brightness(20)",
                }}
                className="any"
              ></div>
            </div>
          }
          setModalVisible={setVisibleProc}
          modalVisible={visibleProc}
          size={"xl"}
          title={Lang.addProcedure}
        /> */}
        {/* Task Details Title and Filter Card */}
        <div
          className={`d-flex flex-column col-11 col-lg-8 col-xl-12 ${customStyle(
            "TitleCard"
          )}`}
        >
          {/* stage of activity if there is activity when we decide
          {details.milestones ? (
            <div
              className="d-flex align-items-center px-3 py-2 mx-4 mt-3"
              style={{
                backgroundColor: "#C7DEFB",
                borderRadius: 4,
                width: "fit-content",
                fontSize: 12,
              }}
            >
              <div className="d-flex justify-content-center align-items-center">
                <p className="m-0">{details.milestone}</p>
              </div>
            </div>
          ) : null} */}

          {/* back to home Link */}
          <div
            className="d-flex align-align-items-center px-4 py-2"
            onClick={() => {
              history(-1);
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                height: 22,
                width: 32,
                cursor: "pointer",
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center"
            >
              <div
                style={{
                  width: 18,
                  height: 20,
                  background:
                    "url('/assets/images/icons/projection-screen.png')",
                  opacity: 1,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <p
              className={`my-0 ${styleEnd("m", 3)} hoverLinks`}
              style={{ lineHeight: 1.5, fontSize: 14 }}
            >
              {Lang.backToProjectsMenu}
            </p>
            {/* </Link> */}
          </div>

          {/* name and icons*/}
          <div className="d-flex  align-items-start px-4 py-1">
            <h5
              className={`my-0 ${styleEnd("m", 3)}`}
              style={{ lineHeight: 1.5, textAlign: "justify" }}
            >
              {details.name}
            </h5>

            <div className="d-flex col justify-content-end my-2 my-md-0">
              <div
                className="mx-2 ms-3 d-flex justify-content-center align-items-center"
                style={{
                  border: "1px solid rgba(199, 199, 201, 1)",
                  borderRadius: 4,
                  height: 32,
                  width: 32,
                  cursor: "pointer",
                }}
                onClick={() => {
                  onshowTaskAttachmentsPopup();
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="12.188"
                  viewBox="0 0 16 12.188"
                >
                  <path
                    id="folder_1_"
                    data-name="folder (1)"
                    d="M15.869,67.188a1.092,1.092,0,0,0-.963-.575H12.813v-2.5a1.251,1.251,0,0,0-1.25-1.25H5.938v-.625a1.251,1.251,0,0,0-1.25-1.25H1.25A1.251,1.251,0,0,0,0,62.237V72.706H0a.468.468,0,0,0,.469.469H12.344a.469.469,0,0,0,.391-.21l3.084-4.657A1.092,1.092,0,0,0,15.869,67.188ZM1.25,61.925H4.688A.313.313,0,0,1,5,62.237v1.094a.469.469,0,0,0,.469.469h6.094a.313.313,0,0,1,.313.313v2.5h-.938V65.206a.469.469,0,0,0-.469-.469H2.344a.469.469,0,0,0-.469.469V69.57l-.938,1.5V62.237a.313.313,0,0,1,.313-.313Zm2.732,4.688a.469.469,0,0,0-.4.22l-.772,1.236V65.675H10v.938Zm11.055,1.179-2.944,4.446H1.314l1.412-2.261a.466.466,0,0,0,.031-.049L4.242,67.55H14.906a.156.156,0,0,1,.131.242Z"
                    transform="translate(0 -60.987)"
                    fill="#12aac4"
                  />
                </svg>
              </div>

              <div className="d-flex justify-content-end align-items-start btn-group">
                {showProject.id == details.id ? (
                  <>
                    <div
                      style={{
                        display: showProject.display ? "block" : "none",
                      }}
                      className={`${customStyle(
                        "arrow-horizontalProjectDetails"
                      )} ${showProject.display ? "show" : ""}`}
                    ></div>
                    <ul
                      className={`${customStyle(
                        "dropdown-menuProjectDetails"
                      )} ${showProject.display ? "show" : ""}`}
                      style={{
                        display: showProject.display ? "block" : "none",
                      }}
                    >
                      <li
                        style={{ cursor: "pointer" }}
                        id={details.id}
                        onClick={(e) => {
                          const currentId = e.currentTarget.id;
                          resolver(
                            getEditDataProjectForm,
                            setData,
                            currentId,
                            communityId,
                            userToken
                          );
                          setProjectId(currentId);
                        }}
                      >
                        <span
                          className={`dropdown-item ${customStyle(
                            "dropdown-item"
                          )}`}
                        >
                          تعديل المشروع
                        </span>
                      </li>
                      <li style={{ cursor: "pointer" }}>
                        <span
                          onClick={() => {
                            setProjectId(details.id);
                            setProjectTitle(details.name);
                            setVisibleStatus(true);
                          }}
                          className={`dropdown-item ${customStyle(
                            "dropdown-item"
                          )}`}
                        >
                          تعديل الحالة
                        </span>
                      </li>
                      <li
                        style={{ cursor: "pointer" }}
                        id={details.id}
                        onClick={(e) => {
                          const currentId = e.currentTarget.id;
                          setProjectId(currentId);
                          onShowAttachments();
                        }}
                      >
                        <span
                          className={`dropdown-item ${customStyle(
                            "dropdown-item"
                          )}`}
                        >
                          اضافة مرفقات
                        </span>
                      </li>
                      <li
                        style={{ cursor: "pointer" }}
                        id={details.id}
                        onClick={(e) => {
                          const currentId = e.currentTarget.id;
                          setProjectId(currentId);
                          onShowMilestonePopup();
                        }}
                      >
                        <span
                          className={`dropdown-item ${customStyle(
                            "dropdown-item"
                          )}`}
                        >
                          {Lang.addMilestone}
                        </span>
                      </li>
                      <li
                        style={{ cursor: "pointer" }}
                        id={details.id}
                        onClick={(e) => {
                          const currentId = e.currentTarget.id;
                          setProjectId(currentId);
                          setDeleteProjectModalVisible(true);
                        }}
                      >
                        <span
                          className={`dropdown-item ${customStyle(
                            "dropdown-item"
                          )}`}
                        >
                          حذف المشروع
                        </span>
                      </li>
                    </ul>
                  </>
                ) : null}
              </div>

              {community?.adminProject && (
                <Icon
                  id={details.id}
                  name="ellipsis-v"
                  size={18}
                  className="icon"
                  containerStyle={"icon align-self-center"}
                  onclick={(e) => {
                    const id = e.currentTarget.id;
                    id == null
                      ? setshowProject({
                          id,
                          display: true,
                        })
                      : id == showProject.id
                      ? setshowProject({
                          id: null,
                          display: false,
                        })
                      : setshowProject({
                          id,
                          display: true,
                        });
                  }}
                />
              )}

              {/* <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  border: "1px solid rgba(199, 199, 201, 1)",
                  borderRadius: 4,
                  height: 32,
                  width: 32,
                  cursor: "pointer",
                }}
                onClick={() => {
                  onshowDetailsPopup();
                }}
              >
                <svg
                  id="description_1_"
                  data-name="description (1)"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                >
                  <path
                    id="Path_353"
                    data-name="Path 353"
                    d="M17.2,2H2.8a.8.8,0,0,0-.8.8V17.2a.8.8,0,0,0,.8.8H17.2a.8.8,0,0,0,.8-.8V2.8A.8.8,0,0,0,17.2,2ZM3.6,3.6H16.4V5.2H3.6ZM16.4,16.4H3.6V6.8H16.4Z"
                    transform="translate(-2 -2)"
                    fill="#1a73e8"
                  />
                  <path
                    id="Path_354"
                    data-name="Path 354"
                    d="M6.8,12.6H14.81a.8.8,0,1,0,0-1.6H6.8a.8.8,0,1,0,0,1.6Z"
                    transform="translate(-2.806 -3.799)"
                    fill="#1a73e8"
                  />
                  <path
                    id="Path_355"
                    data-name="Path 355"
                    d="M6.8,16.6h3.993a.8.8,0,0,0,0-1.6H6.8a.8.8,0,0,0,0,1.6Z"
                    transform="translate(-2.797 -4.598)"
                    fill="#1a73e8"
                  />
                </svg>
              </div> */}

              {/* <div
                style={{
                  backgroundColor: "#1a73e8",
                  height: 32,
                  width: 32,
                  cursor: "pointer",
                  borderRadius: "50%",
                }}
                className="d-flex mx-2 justify-content-center text-center align-items-center filterIcon"
                onClick={(e) => {
                  changeElementActiveClass(e);
                }}
              >
                <div
                  style={{
                    width: 16,
                    height: 24,
                    background:
                      "url('/assets/images/icons/Group 252.png') 0% 0% no-repeat padding-box",
                    opacity: 1,
                  }}
                ></div>
              </div> */}
            </div>
          </div>

          {/* date */}
          <div className="d-flex align-items-center px-4">
            <p className="text-muted" style={{ fontSize: 14 }}>
              {Lang.inPeriod}
              <span>
                &nbsp;&nbsp;&nbsp;{Lang.from}{" "}
                {`${moment(new Date(details.startDate)).format("LL")}`}
              </span>{" "}
              <span>
                &nbsp;&nbsp;&nbsp;{Lang.to}{" "}
                {`${moment(new Date(details.endDate)).format("LL")}`}
              </span>
            </p>
          </div>

          {/* popup details */}
          {/* icons */}
          <div className="d-flex flex-wrap align-items-center px-4">
            {/* <div
              className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
                "m",
                2
              )} mb-2`}
              style={{
                backgroundColor: "#F2F2F2",
                width: "fit-content",
                borderRadius: 10,
              }}
            >
              <div className={`${styleEnd("m", 2)}`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16.883"
                  height="18"
                  viewBox="0 0 16.883 18"
                >
                  <path
                    id="_001-clock"
                    data-name="001-clock"
                    d="M8.442,18.25C.949,18.242-2.821,8.53,2.473,2.871a8.107,8.107,0,0,1,11.938,0C19.7,8.531,15.934,18.242,8.442,18.25Zm0-16.61a7.382,7.382,0,0,0-7.123,7.6c.391,10.084,13.855,10.081,14.245,0A7.382,7.382,0,0,0,8.442,1.64Zm3.071,9.884L9.429,9.3A1.092,1.092,0,0,0,9.1,8.454c0-.007,0-.015,0-.022V4.314a.661.661,0,1,0-1.319,0V8.432c0,.007,0,.015,0,.022A1.066,1.066,0,0,0,8.5,10.3l2.084,2.224a.631.631,0,0,0,.933,0,.738.738,0,0,0,0-1Z"
                    transform="translate(0 -0.25)"
                    fill={details?.dayCount?.color ?? "#3ec4b8"}
                  />
                </svg>
              </div>
              <div className="d-flex align-items-center justify-content-center">
                <p className="my-0">
                  {details.dayCount.day >= 0 ? details.dayCount.day : ""}&nbsp;
                  {details.dayCount.daystatus}
                </p>
              </div>
            </div> */}

            {details?.projectStatus ? (
              <div
                className={`d-flex justify-content-center py-2 px-3 mb-2`}
                style={{
                  backgroundColor: "#F2F2F2",
                  width: "fit-content",
                  borderRadius: 10,
                }}
              >
                <div className={`${styleEnd("m", 2)}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                  >
                    <g
                      id="technical-support_1_"
                      data-name="technical-support (1)"
                      transform="translate(0 0.001)"
                    >
                      <path
                        id="Path_428"
                        data-name="Path 428"
                        d="M3.165,13.919a1.468,1.468,0,0,0-.709.181A8.3,8.3,0,0,1,10.652.867a.352.352,0,0,0,.139-.689A9.067,9.067,0,0,0,9,0,9,9,0,0,0,1.936,14.577a1.477,1.477,0,1,0,1.229-.658Zm.547,2.023a.773.773,0,1,1,.227-.547A.768.768,0,0,1,3.712,15.943Zm0,0"
                        transform="translate(0)"
                        fill={details?.projectStatus?.color}
                      />
                      <path
                        id="Path_429"
                        data-name="Path 429"
                        d="M206.6,34.346a1.473,1.473,0,1,0-.52.477,8.3,8.3,0,0,1-8.18,13.236.352.352,0,1,0-.138.69,9.073,9.073,0,0,0,1.775.175A9,9,0,0,0,206.6,34.346Zm-1.776-.272a.774.774,0,1,1,.547.226A.768.768,0,0,1,204.828,34.074Zm0,0"
                        transform="translate(-190.541 -30.925)"
                        fill={details?.projectStatus?.color}
                      />
                      <path
                        id="Path_430"
                        data-name="Path 430"
                        d="M78.932,86.445a.352.352,0,0,0,.352.352h2.2a.352.352,0,0,0,.352-.352v-.682a5.505,5.505,0,0,0,1.319-.547l.481.481a.351.351,0,0,0,.5,0l1.554-1.555a.352.352,0,0,0,0-.5l-.481-.481a5.5,5.5,0,0,0,.547-1.319h.679a.352.352,0,0,0,.352-.352V79.3a.352.352,0,0,0-.352-.352h-.679a5.505,5.505,0,0,0-.547-1.319l.478-.478a.352.352,0,0,0,0-.5L84.127,75.1a.352.352,0,0,0-.5,0l-.477.477a5.5,5.5,0,0,0-1.319-.547v-.675A.352.352,0,0,0,81.482,74h-2.2a.352.352,0,0,0-.352.352v.675a5.5,5.5,0,0,0-1.319.547l-.477-.477a.352.352,0,0,0-.5,0L75.084,76.65a.351.351,0,0,0,0,.5l.478.478a5.5,5.5,0,0,0-.547,1.319h-.678a.352.352,0,0,0-.352.351v2.2a.351.351,0,0,0,.352.352h.679a5.506,5.506,0,0,0,.547,1.319l-.481.481a.352.352,0,0,0,0,.5L76.635,85.7a.352.352,0,0,0,.249.1h0a.352.352,0,0,0,.249-.1l.481-.481a5.51,5.51,0,0,0,1.319.547Zm-1.182-1.968a.352.352,0,0,0-.439.047l-.428.428-1.057-1.058.428-.428a.351.351,0,0,0,.047-.439,4.812,4.812,0,0,1-.666-1.607.352.352,0,0,0-.344-.278h-.6v-1.5h.6a.352.352,0,0,0,.344-.278,4.812,4.812,0,0,1,.666-1.607.351.351,0,0,0-.047-.439l-.425-.425,1.058-1.057.424.425a.352.352,0,0,0,.439.047,4.81,4.81,0,0,1,1.607-.666.352.352,0,0,0,.278-.344v-.6h1.5v.6a.351.351,0,0,0,.278.344,4.814,4.814,0,0,1,1.607.666.351.351,0,0,0,.439-.047l.425-.424L84.937,76.9l-.425.425a.351.351,0,0,0-.047.439,4.815,4.815,0,0,1,.666,1.607.351.351,0,0,0,.344.278h.6v1.5h-.6a.352.352,0,0,0-.344.278,4.811,4.811,0,0,1-.666,1.607.352.352,0,0,0,.047.439l.428.428-1.057,1.058-.428-.428a.351.351,0,0,0-.439-.047,4.815,4.815,0,0,1-1.607.666.352.352,0,0,0-.278.344v.607h-1.5v-.607a.352.352,0,0,0-.278-.344A4.812,4.812,0,0,1,77.751,84.477Zm0,0"
                        transform="translate(-71.384 -71.399)"
                        fill={details?.projectStatus?.color}
                      />
                      <path
                        id="Path_431"
                        data-name="Path 431"
                        d="M179.181,176.276a2.9,2.9,0,1,0-2.9,2.9A2.908,2.908,0,0,0,179.181,176.276Zm-5.107,0a2.2,2.2,0,1,1,2.2,2.2A2.2,2.2,0,0,1,174.074,176.276Zm0,0"
                        transform="translate(-167.277 -167.277)"
                        fill={details?.projectStatus?.color}
                      />
                      <path
                        id="Path_432"
                        data-name="Path 432"
                        d="M338.43,18.512a.352.352,0,1,0-.248-.1A.354.354,0,0,0,338.43,18.512Zm0,0"
                        transform="translate(-326.193 -17.183)"
                        fill={details?.projectStatus?.color}
                      />
                      <path
                        id="Path_433"
                        data-name="Path 433"
                        d="M154.711,474.359a.352.352,0,1,0,.249.1A.355.355,0,0,0,154.711,474.359Zm0,0"
                        transform="translate(-148.933 -457.683)"
                        fill={details?.projectStatus?.color}
                      />
                    </g>
                  </svg>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <p className="my-0">{details?.projectStatus.name}</p>
                </div>
              </div>
            ) : null}

            {details?.projectPriority ? (
              <div
                className={`d-flex justify-content-center py-2 px-3 mx-2 mb-2`}
                style={{
                  backgroundColor: "#F2F2F2",
                  width: "fit-content",
                  borderRadius: 10,
                }}
              >
                <div className={`${styleEnd("m", 2)}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="14.541"
                    viewBox="0 0 16 14.541"
                  >
                    <g
                      id="Group_303"
                      data-name="Group 303"
                      transform="translate(-708 -230.459)"
                    >
                      <path
                        id="Path_344"
                        data-name="Path 344"
                        d="M12.108,35a2.108,2.108,0,1,0,2.108,2.108A2.108,2.108,0,0,0,12.108,35Zm0,3.3a1.171,1.171,0,1,1,1.171-1.171A1.171,1.171,0,0,1,12.108,38.3Z"
                        transform="translate(700.57 203.164)"
                        fill={details?.projectPriority?.color}
                      />
                      <path
                        id="Path_345"
                        data-name="Path 345"
                        d="M9.529,5A6.436,6.436,0,0,0,3.1,11.246l-.582-.417a.5.5,0,0,0-.645.052L.852,11.906A.5.5,0,0,0,.8,12.55l.5.712-.055.135-.867.145a.5.5,0,0,0-.417.5v1.444a.5.5,0,0,0,.417.5l.867.145.055.135-.5.712a.5.5,0,0,0,.052.645l1.024,1.024a.5.5,0,0,0,.645.052l.715-.5.132.055.145.869a.5.5,0,0,0,.5.417H5.456a.5.5,0,0,0,.5-.417l.145-.869.132-.055.715.5a.5.5,0,0,0,.645-.052l.847-.879A6.43,6.43,0,1,0,9.529,5ZM7.158,16.588,7.6,17.2l-.422.422-.612-.437a.5.5,0,0,0-.532-.035,2.683,2.683,0,0,1-.535.225.5.5,0,0,0-.345.395l-.125.75H4.43l-.125-.75a.5.5,0,0,0-.337-.395,2.683,2.683,0,0,1-.535-.225.5.5,0,0,0-.532.035l-.62.437L1.859,17.2l.437-.612a.5.5,0,0,0,.032-.535,2.581,2.581,0,0,1-.22-.527.5.5,0,0,0-.39-.35l-.75-.125v-.595l.75-.125a.5.5,0,0,0,.39-.337,2.581,2.581,0,0,1,.22-.527.5.5,0,0,0-.032-.535l-.437-.625.422-.422.612.437a.5.5,0,0,0,.535.032,2.581,2.581,0,0,1,.54-.22.5.5,0,0,0,.337-.39L4.43,11h.595l.125.75a.5.5,0,0,0,.35.4,2.581,2.581,0,0,1,.527.22.5.5,0,0,0,.535-.032l.612-.437.422.422-.437.6a.5.5,0,0,0-.035.532,2.683,2.683,0,0,1,.225.535.5.5,0,0,0,.395.345l.75.125v.595l-.75.125a.5.5,0,0,0-.395.345,2.683,2.683,0,0,1-.225.535.5.5,0,0,0,.035.532Zm2.371.275a5.5,5.5,0,0,1-1.014-.1l-.372-.522c.02-.042.037-.087.055-.132l.869-.145a.5.5,0,0,0,.417-.5V14.032a.5.5,0,0,0-.417-.5L8.2,13.387c-.017-.045-.035-.09-.055-.132l.5-.715a.5.5,0,0,0-.052-.645L7.565,10.871a.5.5,0,0,0-.645-.052l-.712.5-.135-.055L5.929,10.4a.5.5,0,0,0-.5-.417H4.29a5.432,5.432,0,1,1,5.247,6.866Z"
                        transform="translate(708.04 225.459)"
                        fill={details?.projectPriority?.color}
                      />
                      <path
                        id="Path_346"
                        data-name="Path 346"
                        d="M37.2,15.108V11.048a.468.468,0,0,0-.937,0V15.3a.468.468,0,0,0,.138.33L38.2,17.438a.47.47,0,0,0,.661-.67Z"
                        transform="translate(680.936 221.186)"
                        fill={details?.projectPriority?.color}
                      />
                    </g>
                  </svg>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <p className="my-0">{details.projectPriority.name}</p>
                </div>
              </div>
            ) : null}

            {details.activities ? (
              <div
                className="d-flex justify-content-center py-2 px-3 mb-2 text-decoration-none text-dark"
                style={{
                  backgroundColor: "#F2F2F2",
                  width: "fit-content",
                  borderRadius: 10,
                }}
              >
                <div className="d-flex">
                  <div
                    className={`d-flex justify-content-center align-items-center ${styleEnd(
                      "m",
                      2
                    )}`}
                    style={{
                      border: "1px solid #1A73E8",
                      backgroundColor: "#1A73E8",
                      color: "white",
                      borderRadius: "50%",
                      width: 24,
                      height: 24,
                      fontSize: 12,
                    }}
                  >
                    {details.activities.length}
                  </div>
                  <div className="d-flex align-items-center justify-content-center">
                    <p className="my-0">
                      {details.activities.length > 1
                        ? Lang.activity
                        : Lang.activities}
                    </p>
                  </div>
                </div>
              </div>
            ) : null}

            <div
              className="d-flex justify-content-center py-2 px-3 mx-2 mb-2 text-decoration-none text-dark"
              style={{
                backgroundColor: "#F2F2F2",
                width: "fit-content",
                borderRadius: 10,
              }}
            >
              <div className="d-flex">
                <div
                  className={`d-flex justify-content-center align-items-center ${styleEnd(
                    "m",
                    2
                  )}`}
                  style={{
                    border: "1px solid #1A73E8",
                    backgroundColor: "#1A73E8",
                    color: "white",
                    borderRadius: "50%",
                    width: 24,
                    height: 24,
                    fontSize: 12,
                  }}
                >
                  {details?.members?.length + details?.adminMembers?.length > 0
                    ? details?.members?.length + details?.adminMembers?.length
                    : 0}
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <p className="my-0">
                    {details?.members?.length + details?.adminMembers?.length >
                    1
                      ? Lang.Entities
                      : Lang.Entity}
                  </p>
                </div>
              </div>
            </div>

            {/* milestones */}
            <div
              className="d-flex justify-content-center py-2 px-3 mb-2 text-decoration-none text-dark"
              style={{
                backgroundColor: "#F2F2F2",
                width: "fit-content",
                borderRadius: 10,
              }}
            >
              <div className="d-flex">
                <div
                  className={`d-flex justify-content-center align-items-center ${styleEnd(
                    "m",
                    2
                  )}`}
                  style={{
                    border: "1px solid #1A73E8",
                    backgroundColor: "#1A73E8",
                    color: "white",
                    borderRadius: "50%",
                    width: 24,
                    height: 24,
                    fontSize: 12,
                  }}
                >
                  {details?.milestones?.length > 0
                    ? details?.milestones?.length
                    : 0}
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <p className="my-0">
                    {details?.milestones?.length > 1
                      ? Lang.milestones
                      : Lang.milestone}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* community */}
          {/* <div className="d-flex flex-column flex-wrap px-4 py-2">
            <div>
              <p className="mb-1 fw-bold">{Lang.workAxes}</p>
            </div>
            <div>
              <p
                dangerouslySetInnerHTML={{
                  __html: details?.communityName?.replaceAll("\n", "<br />"),
                }}
              />
            </div>
          </div> */}

          {/* description */}
          <div className="d-flex align-items-end">
            <div className="d-flex flex-column flex-wrap col px-4 py-2">
              <div>
                <p className="mb-1 fw-bold">{Lang.Description}</p>
              </div>
              <div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: details?.description
                      ? details?.description?.replaceAll("\n", "<br />")
                      : Lang.noDescription,
                  }}
                />
              </div>
            </div>

            {details?.adminMembers?.length > 0 ||
            details?.members?.length > 0 ||
            milestones.count > 0 ? (
              <Button
                buttonStyleType={"solid"}
                inputStyle={"col-10"}
                containerStyle={
                  "col-xl-2 col-md-3 col-sm-4 col-5 mt-2 px-3 py-2 mb-2"
                }
                onClick={() => {
                  display == false ? setDisplay(true) : setDisplay(false);
                }}
                content={display == false ? Lang.seeMore : Lang.collapse}
              />
            ) : null}
          </div>

          {/* members */}

          {display ? (
            <Pulse collapse opposite>
              <div className="d-flex flex-column justify-content-center align-items-md-start align-items-center">
                {details?.adminMembers?.length > 0 ? (
                  <div className="d-flex flex-column mb-4 col-12">
                    <div
                      className={`d-flex flex-column px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                        "TitleCard"
                      )}`}
                      style={{
                        height: "fit-content",
                        maxHeight: 250,
                      }}
                    >
                      <div className="d-flex mb-3">
                        <p style={{ color: "#1A73E8" }}>{Lang.adminMembers}</p>
                      </div>

                      <div className="d-flex flex-wrap scroll">
                        {details.adminMembers.map((item, index) => {
                          let userPhoto;
                          if (item?.memberPhoto != null)
                            userPhoto = `url("${paths.MemberPhoto}${item.id}/${item.memberPhoto}")`;
                          else
                            userPhoto = `url("/assets/images/userPlaceholder.png")`;
                          return (
                            <div
                              className="d-flex col-md-6 col-12 mb-3"
                              key={item.id}
                            >
                              <div className="d-flex align-items-center justify-content-start col-12">
                                <div
                                  style={{
                                    backgroundImage: userPhoto,
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    border: "1px solid white",
                                  }}
                                ></div>
                                <p
                                  className="my-0 mx-1 col-9"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {item.memberName}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ) : null}

                {details.members.length > 0 ? (
                  <div className="d-flex flex-column mb-4 col-12">
                    <div
                      className={`d-flex flex-column px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                        "TitleCard"
                      )}`}
                      style={{
                        height: "fit-content",
                        maxHeight: 250,
                      }}
                    >
                      <div className="d-flex mb-3">
                        <p style={{ color: "#1A73E8" }}>{Lang.Members}</p>
                      </div>
                      <div className="d-flex flex-wrap scroll">
                        {details.members.map((item, index) => {
                          let userPhoto;
                          if (item?.memberPhoto != null)
                            userPhoto = `url("${paths.MemberPhoto}${item.id}/${item.memberPhoto}")`;
                          else
                            userPhoto = `url("/assets/images/userPlaceholder.png")`;
                          return (
                            <div
                              className="d-flex col-md-6 col-12 mb-3"
                              key={item.id}
                            >
                              <div className="d-flex align-items-center justify-content-start col-12">
                                <div
                                  style={{
                                    backgroundImage: userPhoto,
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    border: "1px solid white",
                                  }}
                                ></div>
                                <p
                                  className="my-0 mx-1 col-9"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {item.memberName}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ) : null}

                {milestones.count > 0 ? (
                  <div className="d-flex flex-column mb-5 col-12">
                    <div
                      className={`d-flex flex-column px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                        "TitleCard"
                      )}`}
                      style={{
                        height: "fit-content",
                        maxHeight: 250,
                      }}
                    >
                      <div className="d-flex mb-3">
                        <p style={{ color: "#1A73E8" }}>{Lang.milestones}</p>
                      </div>
                      <div className="d-flex flex-wrap scroll">
                        {milestones.data.map((item, index) => {
                          return (
                            <div
                              className="d-flex col-md-6 col-12 mb-3"
                              key={item.id}
                            >
                              <div className="d-flex align-items-center justify-content-start col-9">
                                <p
                                  className="my-0 mx-1 col-9"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {item.name}
                                </p>
                              </div>
                              {community?.adminProject && (
                                <div className="d-flex align-items-center col-1">
                                  <Icon
                                    size={18}
                                    id={item.id}
                                    color="#1a73e8"
                                    name="edit"
                                    className="sideAny"
                                    style={{ display: "block" }}
                                    onclick={(e) => {
                                      const currentId = e.currentTarget.id;
                                      setMilestoneId(currentId);
                                      setMilestone(item);
                                      onshowEditMilesonePopup();
                                    }}
                                  />
                                </div>
                              )}
                              {community?.adminProject && (
                                <div className="d-flex align-items-center col-1">
                                  <Icon
                                    size={18}
                                    id={item.id}
                                    color="#1a73e8"
                                    name="trash"
                                    className="sideAny"
                                    style={{ display: "block" }}
                                    onclick={(e) => {
                                      const currentId = e.currentTarget.id;
                                      setMilestoneId(currentId);
                                      setDeleteModalVisible(true);
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </Pulse>
          ) : null}
        </div>
        <div className="d-flex flex-column w-100">
          {/* title */}
          <Titlebar
            width={"col-11 col-lg-8 col-xl-12"}
            title={Lang.activities}
            customImage={"/assets/images/icons/007-layers.png"}
          />

          {/* small screens button */}
          {community?.adminProject && (
            <CardWithTitleAndIcon
              containerStyle="d-lg-none d-flex justify-content-center align-items-center col-12 mt-4 align-self-center mb-3"
              borderColor={"rgba(68, 68, 68, 0.25)"}
              height={90}
              width={200}
              onClick={() => {
                onShow();
              }}
              customImage={"/assets/images/Group 8262.png"}
              imgHeight={50}
              imgWidth={60}
              containerImgHeight={50}
              containerImgWidth={60}
              cardTitle={Lang.createNewActivity}
              boxShadow={"6px 6px 12px 0px rgb(0 0 0 / 20%)"}
            />
          )}

          {/* Cards Listing Start */}
          <div className="d-flex flex-lg-row flex-column-reverse flex-wrap align-items-center">
            {/* Task Card */}
            <ActivityCard
              projectId={id}
              ActivitiesWithProcedures={details.activities}
              // communityTaskForm={communityTaskForm}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />

            {/* lg screens button */}
            {community?.adminProject && (
              <CardWithTitleAndIcon
                containerStyle={`d-lg-flex d-none flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 position-fixed ${customStyle(
                  "createTaskButton"
                )}`}
                borderColor={"rgba(68, 68, 68, 0.25)"}
                height={180}
                width={180}
                onClick={() => {
                  onShow();
                  // setCreateContent(communityTaskForm);
                }}
                customImage={"/assets/images/Group 8262.png"}
                imgHeight={70}
                imgWidth={80}
                containerImgHeight={70}
                containerImgWidth={80}
                cardTitle={Lang.createNewActivity}
                boxShadow={"6px 6px 12px 0px rgb(0 0 0 / 20%)"}
              />
            )}

            {renderModal()}
          </div>
          {/* Cards Listing End */}
        </div>
        {renderProjectAttachmentsModal()}
        {milestoneId != 0 && dropdowns?.data
          ? renderEditMilestoneModal()
          : null}
        {renderAttachmentsModal()}
        {renderMilestoneModal()}
        {/* {renderDetailsModal(details)} */}
      </>
    );
  } else return <div>no details</div>;
};

export default ProjectDetails;
